import React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

// Components 

import TextField from '@mui/material/TextField';

interface Props { 
    title?: string
}

const Legend: React.FC<Props> = ({title}) => {

  const colors = useAppSelector(state => state.theme.colors);  

  const usersListLength = useAppSelector(state => state.adminUserAccess.usersListLength); 

  return (

      <Box sx={{ 
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '7.5vh',
        width: '100%',
        paddingLeft: '1%',
        backgroundColor: colors?.listHeaderBackground,
        color: colors?.text, 
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        padding: '0 1vw',
    }}>

      <>

        <div style={{  width: '23%', marginLeft: '2%' }}>User</div>

        <Box sx={{ width: '20%' }}>Email</Box>

        <Box sx={{ width: '45%' }}>CreatedAt</Box>

        <Box sx={{ width: '10%' }}>More</Box>

      </>


  </Box>

  );

};

export default Legend;